import React from "react"
import Carousel from "@brainhubeu/react-carousel"
import "@brainhubeu/react-carousel/lib/style.css"
import { UilAngleRight, UilAngleLeft } from "@iconscout/react-unicons"

const defaultBreakpoints = {
  640: {
    slidesPerPage: 1,
    arrows: true,
  },
  900: {
    slidesPerPage: 2,
    arrows: true,
  },
}

const CarouselComponent = ({ images, slides = 2, breakpoints = defaultBreakpoints }) => {
  return (
    <Carousel
      slidesPerPage={slides}
      arrows
      infinite
      arrowRight={<UilAngleRight size="40" />}
      arrowLeft={<UilAngleLeft size="40" />}
      addArrowClickHandler
      className={'c-carousel'}
      offset={10}
      breakpoints={breakpoints}>
      {images.map(img => {
        return (
          <div className="p-article__carousel--slide">
            <img
              src={img}
              style={{ maxWidth: "100%", borderRadius: "10px", marginLeft: '-5px', zIndex: '1', position: 'relative'}}
            />
          </div>
        )
      })}
    </Carousel>
  )
}

export default CarouselComponent
